export const contactSupport = {
  support_title_message: "Kontak ons en ons sal dit saam oplos!",
  support_message: "Vrae? Stuur vir ons 'n boodskap op WhatsApp of e-pos. Ons is hier om te help.",
  support_modal_email: "E-pos",
};
